/**
 * Snapshot of the active session tab for Talk to Heidi context.
 * Published by session UI; consumed by the voice controller hint builder.
 */
import { atom } from 'jotai';

export type VoiceActiveTabSnapshot = {
  sessionId: string;
  /** note | document | transcript | context | … */
  tabKind: string;
  documentId?: string;
  templateId?: string;
  /** Human label when known (template name or document/tab title). */
  templateName?: string;
  voiceStyle?: string;
};

export const voiceActiveTabAtom = atom<VoiceActiveTabSnapshot | null>(null);
